/**
 * @generated SignedSource<<f38a889abdd59c02bffd8d6eede9ff87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksBuildSpeechifyConfigArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPostiesArticle">;
  readonly " $fragmentType": "hooksBuildSpeechifyConfigArticle";
};
export type hooksBuildSpeechifyConfigArticle$key = {
  readonly " $data"?: hooksBuildSpeechifyConfigArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksBuildSpeechifyConfigArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksBuildSpeechifyConfigArticle",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsPostiesArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SectionSegment",
          "kind": "LinkedField",
          "name": "sections",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Section",
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "9e86ff8c68b19559935b41d06434c76a";

export default node;
